<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="companymaster" (ngSubmit)="Validate(companymaster)" #companymaster="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Company Policy
                </div>
                <div class="card-body">
                    <div class="ms-5">
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="policyname" class="form-label text-label-dark">Policy Name:
                                </label>
                            </div>
                            <div class="col-md-5">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                    id="policyname" name="policyname" [(ngModel)]="DetailDate.ESS_CompanyPolicyTitle"
                                    #policyname="ngModel" maxlength="100" required>
                                <div class="invalid-feedback">
                                    Please Enter Policy Name!
                                </div>
                            </div>
                            <div class="col-md-1 align-self-center">
                                <label for="policyname" class="form-label text-label-dark">Icon :
                                </label>
                            </div>
                            <div class="col-md-3">
                                <div class="file-input-container">
                                    <input class="form-control form-control-sm" id="FileSm" name="FileSm"
                                        type="file" *ngIf="!DetailDate.Icon" [(ngModel)]="Icon1"
                                        #formFileSm="ngModel" (change)="onFileSelected($event,'Icon')" accept="image/*"
                                         />
                                    <span *ngIf="DetailDate.Icon" class="file-name">{{
                                        DetailDate.Icon
                                        }}</span>
                                    <span *ngIf="DetailDate.Icon "> <button class="btn btn-sm" name="view1"
                                            type="button" style="color: blue;" (click)="viewFile('Icon')"><i
                                                class="bi bi-eye"></i></button></span>
                                    <button class="btn btn-sm" name="delete1" type="button"
                                        *ngIf="DetailDate.Icon" (click)="removeFile('Icon')">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="companypolicytype" class="text-label-dark">Policy Type:</label>
                            </div>
                            <div class="col-md-4">
                                <ng-select name="companypolicytype" id="companypolicytype" [items]="CompanyPolicyLoad"
                                    bindLabel="ESS_CompanyPolicyTypeTitle" bindValue="ESS_CompanyPolicyTypeMasterID"
                                    [(ngModel)]="DetailDate.ESS_CompanyPolicyTypeMasterID" #companypolicytype="ngModel"
                                    placeholder="Select Policy type" required>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select Company Policy Type!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="DefaultRule" class="form-label text-label-dark">Employee Type:</label>
                            </div>
                            <div class="col-md-5">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.DetailDate.ESS_CompanyPolicyMasterID == 0) || (this.DetailDate.ESS_CompanyPolicyMasterID > 0 && common.ToLowerCase(DetailDate.EmpType) == 'front')">
                                        <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                            [(ngModel)]="DetailDate.EmpType" [ngModelOptions]="{standalone: true}"
                                            (change)="GetApplicability()"
                                            [disabled]="DetailDate.ESS_CompanyPolicyMasterID > 0" required>
                                        Front Office
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                        *ngIf="(this.DetailDate.ESS_CompanyPolicyMasterID == 0) || (this.DetailDate.ESS_CompanyPolicyMasterID > 0 && common.ToLowerCase(DetailDate.EmpType) == 'back')">
                                        <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                            [(ngModel)]="DetailDate.EmpType" [ngModelOptions]="{standalone: true}"
                                            (change)="GetApplicability()"
                                            [disabled]="DetailDate.ESS_CompanyPolicyMasterID > 0" required>
                                        Back Office
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="Aknowledement" class="form-label text-label-dark">
                                    Aknowledgement :</label>
                            </div>
                            <div class="col-md-2">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="Aknowledgement"
                                            [(ngModel)]="DetailDate.Aknowledgement"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="Aknowledgement"
                                            [(ngModel)]="DetailDate.Aknowledgement"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="Allowtodownload" class="form-label text-label-dark">
                                    Is Allow To Download :</label>
                            </div>
                            <div class="col-md-2">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="Allowtodownload"
                                            [(ngModel)]="DetailDate.Allowtodownload"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false
                                            name="Allowtodownload" [(ngModel)]="DetailDate.Allowtodownload"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="description" class="form-label text-label-dark">Description :
                                </label>
                            </div>
                            <div class="col-md-5">
                                <textarea class="form-control" maxlength="800" rows="3" id="description"
                                    name="description" placeholder="Ex. Description"
                                    [(ngModel)]="DetailDate.Description" #description="ngModel"></textarea>
                                <div class="invalid-feedback">
                                    Please Enter Description!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-2">
                                <label for="Active" class="form-label text-label-dark">Active :</label>
                            </div>
                            <div class="col-md-5">
                                <input class="form-check-input" style="height: 16px; width: 16px;" name="Active"
                                    type="checkbox" value="" [(ngModel)]="DetailDate.Active" />
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2 align-self-center">
                                <label for="validtill" class="form-label text-label-dark">Valid Till :
                                </label>
                            </div>
                            <div class="col-md-3">
                                <div class="input-group" style="height: auto;">
                                    <input class="form-control" name="validtill" placeholder="Ex. DD MMM YYYY"
                                        ngbDatepicker #d="ngbDatepicker" [(ngModel)]="DetailDate.ValidTillDateObj"
                                        [minDate]="{ year:1930, month: 12, day: 31 }"
                                        [maxDate]="{ year: 2124, month: 12, day: 31 }" #validtill="ngModel" readonly
                                        required />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                                        type="button"></button>
                                </div>
                                <div class="invalid-feedback">
                                    Please select Valid Till Date!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-2">
                                <label for="TrainingVideo" class="form-label text-label-dark">
                                    Is Training Video :</label>
                            </div>
                            <div class="col-md-2">
                                <div class="btn-group btn-group-toggle">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=true name="TrainingVideo"
                                            [(ngModel)]="DetailDate.IsTrainingVideo"
                                            [ngModelOptions]="{standalone: true}">
                                        Yes
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]=false name="TrainingVideo"
                                            [(ngModel)]="DetailDate.IsTrainingVideo"
                                            [ngModelOptions]="{standalone: true}">
                                        No
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-5" *ngIf="DetailDate.IsTrainingVideo">
                                <input type="text" class="form-control text-label-light" placeholder="Ex. Url"
                                    id="TrainingURL" name="TrainingURL" [(ngModel)]="DetailDate.TrainingURL"
                                    #TrainingURL="ngModel" maxlength="100" required>
                                <div class="invalid-feedback">
                                    Please Enter URL!
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" *ngIf="!DetailDate.IsTrainingVideo">
                            <div class="col-md-2 align-self-center">
                                <label for="document" class="form-label text-label-dark">Document :
                                </label>
                            </div>
                            <div class="col-md-5">
                                <div class="file-input-container">
                                    <input class="form-control form-control-sm" id="formFileSm" name="formFileSm"
                                        type="file" *ngIf="!DetailDate.DocumentAttachment" [(ngModel)]="Image"
                                        #formFileSm="ngModel" (change)="onFileSelected($event,'File')" accept=".pdf,image/*"
                                        required />
                                    <span *ngIf="DetailDate.DocumentAttachment" class="file-name">{{
                                        DetailDate.DocumentAttachment
                                        }}</span>
                                    <span *ngIf="DetailDate.DocumentAttachment "> <button class="btn btn-sm" name="view"
                                            type="button" style="color: blue;" (click)="viewFile('File')"><i
                                                class="bi bi-eye"></i></button></span>
                                    <button class="btn btn-sm" name="delete" type="button"
                                        *ngIf="DetailDate.DocumentAttachment" (click)="removeFile('File')">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="DetailDate.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && DetailDate.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="(this.common.PageRight.IsAdd && this.DetailDate.ESS_CompanyPolicyMasterID == 0) || (this.common.PageRight.IsEdit && this.DetailDate.ESS_CompanyPolicyMasterID > 0)"><i
                        class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>